"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiStoryblok = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StoryBlokPage = _interopRequireDefault(require("../StoryBlokPage/StoryBlokPage"));

var _customIcons = require("../../utils/customIcons");

var _customComponents = require("../../utils/customComponents");

var _customLoader = require("../../utils/customLoader");

var MuiStoryblok = function MuiStoryblok(_ref) {
  var theme = _ref.theme,
      accessToken = _ref.accessToken,
      version = _ref.version,
      useObjectTheme = _ref.useObjectTheme,
      iconArray = _ref.iconArray,
      customComponents = _ref.customComponents,
      customLoader = _ref.customLoader,
      dynamicSlug = _ref.dynamicSlug;
  // If a custom loader is passed down push into customLoader variable
  if (customLoader) (0, _customLoader.setCustomLoader)(customLoader);
  (0, _customIcons.pushToCustomIcons)(iconArray);
  (0, _customComponents.pushToCustomComponents)(customComponents);
  return /*#__PURE__*/_react.default.createElement(_StoryBlokPage.default, {
    useObjectTheme: useObjectTheme,
    theme: theme,
    accessToken: accessToken,
    version: version,
    dynamicSlug: dynamicSlug
  });
};

exports.MuiStoryblok = MuiStoryblok;
var _default = MuiStoryblok;
exports.default = _default;
MuiStoryblok.propTypes = {
  dynamicSlug: _propTypes.default.string,

  /** theme for mui */
  theme: _propTypes.default.shape(),

  /** storyblok prop  'published' : 'draft' */
  version: _propTypes.default.string,

  /** access key from storyblok you can make them in storyblok settings */
  accessToken: _propTypes.default.string.isRequired,

  /** Custom App Loader for storyblok */
  customLoader: _propTypes.default.element,

  /**
   * override url theme to edit in mui-theme tool
   */
  useObjectTheme: _propTypes.default.bool,

  /**
   * pass an array of icons to render custom icons in MuiIcon component
   * ex :
   *  [{
      iconName: 'cool_thing',
      Component: MyCoolIcon,
      props: {viewBox: '0 0 267.34 369.6' },
   * }]
   */
  iconArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    iconName: _propTypes.default.string.isRequired,
    Component: _propTypes.default.element.isRequired,
    props: _propTypes.default.shape({}).isRequired
  })),

  /**
   * Important you can add and use customComponets to any sotyblok componet that uses content prop
   * ex [{ componentName: 'MyCoolComp', Component: MyCoolComp, props: {} }]
   */
  customComponents: _propTypes.default.arrayOf(_propTypes.default.shape({
    componentName: _propTypes.default.string.isRequired,
    Component: _propTypes.default.func.isRequired,
    props: _propTypes.default.shape({}).isRequired
  }))
};
MuiStoryblok.defaultProps = {
  theme: {},
  version: 'draft',
  useObjectTheme: false,
  iconArray: [],
  customComponents: [],
  customLoader: undefined,
  dynamicSlug: 'page-welcome'
};